import { useQuery } from '@tanstack/react-query';
import { getBrandingByInstitute } from '../services/branding';
import { ONE_DAY } from '../utils/constants';

export type Args = {
  instituteID: string;
};

export const useBranding = (instituteID: string) => {
  return useQuery({
    queryKey: ['branding', instituteID],
    queryFn: () => getBrandingByInstitute(instituteID?.toUpperCase()),
    staleTime: ONE_DAY,
    retry: false,
  });
};
